import { Images } from '@/assets';
import { useLoading } from '@/context/LoadingContext';
import styled from 'styled-components';

const LoadingSpinner = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <Backdrop>
      <LoadingGif src={Images.LoadingSpinnerGif} alt="Loading..." />
    </Backdrop>
  );
};

export default LoadingSpinner;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(219, 219, 219, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  width: 100%;
`;

const LoadingGif = styled.img`
  width: 140px;
  height: 140px;
`;
